/**
 * A chave pública VAPID, em base64url.
 *
 * **NÃO é segredo, e por isso mora no código.** Ela vai para dentro do bundle
 * de qualquer jeito — o navegador precisa dela para criar a `PushSubscription`
 * —, e pô-la numa variável de ambiente daria a impressão de que é sensível,
 * além de mais um valor para o build errar. Quem é segredo é a **privada**, que
 * vive no Secret Manager e só a Cloud Function lê.
 *
 * Gerada em 2026-09-01 junto do par que está em `VAPID_PRIVATE_KEY`. As duas
 * metades **têm de casar**: trocar uma sem a outra faz todo push falhar com
 * `403 VapidPkHashMismatch`, e as inscrições já criadas param de valer — elas
 * carregam a chave pública de quando nasceram. Se um dia isso for rotacionado,
 * as inscrições precisam ser recriadas.
 *
 * Ponto não comprimido P-256: 65 bytes, 87 caracteres em base64url, começando
 * por `B` (o `0x04` do prefixo). Ver `vapid-public-key.test.ts`, que confere a
 * forma — uma chave truncada num copiar-e-colar produziria um erro só no
 * primeiro push de verdade.
 */
export const VAPID_PUBLIC_KEY =
  'BBNN-y_TnmEON-ZkIS2CqNHRhvkEHXtoNdImGPsVK33kujrbIBlKhN0czS0GYGOXZQ5X60elk8tD8TdTl979IXE'
